import { render, staticRenderFns } from "./PromotionReport.vue?vue&type=template&id=45b02f12&scoped=true"
import script from "./PromotionReport.vue?vue&type=script&lang=js"
export * from "./PromotionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b02f12",
  null
  
)

export default component.exports